import Framework from '@greenville/framework';
import { applySnapshot, types } from 'mobx-state-tree';
import { toJS } from 'mobx';
import * as constants from '../../../common/constants';

const TenantDataModel = types
  .model('TenantDataModel', {
    tenantId: types.maybeNull(types.string),
    tenantKey: types.maybeNull(types.string),
    name: types.maybeNull(types.string),
    isSuperAdmin: types.maybeNull(types.boolean),
    loginPermissions: types.optional(types.array(types.string), [])
  })
  .views((self) => ({
    get tenantData() {
      return toJS(self.data);
    }
  }))
  .actions((self) => ({
    setResponse(response) {
      const plainResponse = toJS(response); // ensure plain snapshot
      applySnapshot(self, plainResponse);
      Framework.getEventManager().publish(constants.SET_TENANT_DATA);
    }
  }));

export default TenantDataModel;
